import { render, staticRenderFns } from "./dealdialog.vue?vue&type=template&id=ecd859e8&scoped=true&"
import script from "./dealdialog.vue?vue&type=script&lang=js&"
export * from "./dealdialog.vue?vue&type=script&lang=js&"
import style0 from "./dealdialog.vue?vue&type=style&index=0&id=ecd859e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd859e8",
  null
  
)

export default component.exports